define(['integration/quoteandbind/SupportedLobModules', 'edge/quoteandbind/quickquote/app', 'edge/policyjob/app', 'edge/platform/navigation/module',
    'edge/platform/basler/module', 'edge/quoteandbind/mfp/app', 'edge/platform/baslerquestionsets/module',
], (SupportedLobModules) => {

    SupportedLobModules.push('edge.quoteandbind.quickquote.app');
    SupportedLobModules.push('edge.policyjob.app');
    SupportedLobModules.push('edge.platform.navigation');
    SupportedLobModules.push('edge.platform.basler');
    SupportedLobModules.push('edge.platform.baslerquestionsets');

    return angular.module('edge.quoteandbind.app', SupportedLobModules)
        .config(['EventHubProvider', (EventHubProvider) => {
            const quoteAndBindMethods = [
                'create',
                'retrieve',
                'saveAndQuote',
                'bind',
            ];

            EventHubProvider.registerTransformer({
                source: {
                    category: 'tracking',
                    eventName: 'serverCall',
                },
                target: {
                    category: 'journey',
                    eventName: 'submission',
                },
                transformer(payload, send) {
                    if (payload
                        && payload.success
                        && (payload.path === 'quote')
                        && quoteAndBindMethods.includes(payload.method)) {
                        const {quoteID, draftData} = payload.response;
                        const newPayload = {
                            method: payload.method,
                            accountNumber: draftData.accountNumber,
                            quoteID: quoteID,
                            productCode: draftData.productCode,

                        };

                        // basler note: no difference in 'bind' method since we don't policy number
                        send(newPayload);
                    }
                },
            });

            EventHubProvider.registerTransformer({
                source: {
                    category: 'tracking',
                    eventName: 'serverCall',
                },
                target: {
                    category: 'tracking',
                    eventName: 'journey',
                },
                transformer(payload, send) {
                    if (payload.path === 'quote' && payload.success) {
                        if (payload.method === 'create') {
                            const {quoteID, draftData} = payload.response;
                            send({
                                eventName: 'Submission Created',
                                accountNumber: draftData.accountNumber,
                                jobID: quoteID,
                                productCode: draftData.productCode,
                                accountHolder: {
                                    name: '', //draftData.accountHolder.displayName, // Upgrade 5.1 => no display name at this time yet
                                    address: '', //draftData.accountHolder.primaryAddress.displayName, // Upgrade 5.1 => no display name at this time yet
                                    email: '', //draftData.accountHolder.emailAddress1 // Upgrade 5.1 => no email address at this time yet
                                },
                            });
                        } else if (payload.method === 'retrieve') {
                            const {quoteID, draftData} = payload.response;
                            send({
                                eventName: 'Submission Retrieved',
                                accountNumber: draftData.accountNumber,
                                jobID: quoteID,
                                productCode: draftData.productCode,
                            });
                        } else if (payload.method === 'saveAndQuote') {
                            const {draftData, quoteData, quoteID} = payload.response;


                            if (quoteData) {
                                quoteData.offeredQuotes.forEach((q) => {
                                    if (!q.isCustom) {
                                        send({
                                            eventName: 'Quote Showed',
                                            accountNumber: draftData.accountNumber,
                                            jobID: quoteID,
                                            productCode: draftData.productCode,
                                            branchCode: q.branchCode,
                                            value: q.total,
                                        });
                                    }
                                });
                            }


                        } else if (payload.method === 'bind') {
                            const {
                                bindData, draftData, quoteData, quoteID,
                            } = payload.response;
                            send({
                                eventName: 'Policy Bound',
                                accountNumber: draftData.accountNumber,
                                policyNumber: bindData.policyNumber,
                                jobID: quoteID,
                                paymentPlan: '', //bindData.paymentPlans[0].name, B028003 - Upgrade 5.1
                                value: quoteData.offeredQuotes[0].total,
                            });
                        }
                    } else if (payload.path === 'customquote' && payload.method === 'updateCustomQuote' && payload.success) {
                        const {response} = payload;
                        send({
                            eventName: 'Quote Showed',
                            jobID: response.quoteID,
                            branchCode: response.branchCode,
                            value: response.total,
                        });
                    }
                },
            });
        }])

        .run(['ExpressionLanguageService', 'AddressLookupService', function (ExpressionLanguage, AddressLookupService) {
            ExpressionLanguage.getCompilationContext('pc').registerType('ch.baloise.gw.pc.edge.capabilities.policycommon.addresslookup.BaslerAddressLookupHandler', {
                validateStreet: function (postalCode, city, street) {
                    const result = AddressLookupService.validateStreet('textToStreetValidation', postalCode, city, street);
                    return result;
                },
            });
        }])

        .run(['ExpressionLanguageService', 'MFPValidationService', function (ExpressionLanguage, MFPValidationService) { // eslint-disable-line no-shadow
                ExpressionLanguage.getCompilationContext('pc').registerType('ch.baloise.gw.pc.edge.aspects.validation.utils.BaslerValidationFunctions', {
                    replaceAll: MFPValidationService.replaceAll,
                    toLowerCase: MFPValidationService.toLowerCase,
                });
        }]);
});



// WEBPACK FOOTER //
// ./app/customer/js/src/edge/quoteandbind/app.js